import { useCallback, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import LoginForm from './LoginForm';
// import LoginHelp from './LoginHelp';

import api from 'api';
import Alert from 'components/Alert';
import Button from 'components/Button';
import Logo from 'components/Logo';
import PermissionContext from 'context/permission.context';
import UserContext from 'context/user.context';
// import AppContext from 'context/app.context';
import { setAuthorizationToken } from 'utils/authorization';
import { setUser } from 'actions/user.action';
import { handleHttpError } from 'utils/httpError';
// import { ReactComponent as FillFormImage } from 'assets/illustrations/smart.svg';
import DonutImage from 'assets/illustrations/donut.png';
import DonutOrbitImage from 'assets/illustrations/donut-orbit.png';
// import { ReactComponent as LeafImage } from 'assets/illustrations/leaf.svg';
import Typography from 'components/Typography';
// import { unsetBackendURL } from 'actions/app.action';
// import CloseAppButton from 'components/Helpers/CloseAppButton';
import HttpRequest from 'utils/httpRequest';
import sponsor from 'assets/images/sponsor.png';
import configuration from 'configuration';

function LoginPage() {
  const history = useHistory();
  const [permissions] = useContext(PermissionContext);
  const [, dispatchUser] = useContext(UserContext);
  // const [, dispatchApp] = useContext(AppContext);

  // const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);

  const areAllPermissionsAllowed = true;
  // const areAllPermissionsAllowed = useMemo(
  //   () => permissions.cameraAllowed,
  //   [permissions.cameraAllowed]
  // );

  const handleSubmit = useCallback(
    async (values, { setSubmitting, setErrors }) => {
      try {
        const data = {
          ...values,
          time: Date.now(),
        };
        const resultLogin = await new HttpRequest(api.auth.login())
          .setData(data)
          .call();

        localStorage.setItem('lastLoginUsername', values.username);

        const { token } = resultLogin.data.data;
        setAuthorizationToken(token);

        const resultProfile = await new HttpRequest(
          api.profile.detail()
        ).call();
        const user = resultProfile.data.data;
        dispatchUser(setUser(user));

        // Auto redirect to /dashboard path
      } catch (err) {
        setSubmitting(false);
        localStorage.removeItem('token');

        if (err.response.status === 400) setErrors(err.response.data.errors);
        else handleHttpError(err);
      }
    },
    [dispatchUser]
  );

  const handleSimulationClick = () => {
    history.push('/simulasi');
  };

  return (
    <>
      <div className="grid grid-cols-12 h-screen">
        <div
          className="fixed inset-0 flex items-center h-auto max-h-screen overflow-y-auto"
          style={{ zIndex: 2 }}
        >
          <div className="container m-auto flex flex-wrap content-center w-full max-w-lg bg-white shadow-lg rounded-xl">
            <div className="md:px-12 px-6 py-8 w-full">
              <Logo />

              <Typography variant="heading2" gutterBottom className="mt-5">
                Login
              </Typography>

              {areAllPermissionsAllowed ? (
                <>
                  <Typography color="muted" variant="subtitle3" gutterBottom>
                    Silakan login menggunakan nomor ujian dan tanggal lahir apa
                    saja untuk keperluan simulasi
                  </Typography>

                  <Alert color="warning" withBorder className="mt-2">
                    <Typography as="div" variant="paragraph">
                      Pelaksanaan simulasi disarankan menggunakan perangkat
                      <strong> PC atau laptop</strong> agar dapat berjalan
                      secara optimal.
                    </Typography>
                  </Alert>
                </>
              ) : (
                <Alert color="danger" withBorder>
                  <Typography
                    as="div"
                    gutterBottom
                    className="2xl:mt-3 mt-2"
                    variant="paragraph"
                  >
                    <Typography className="font-medium" gutterBottom>
                      Aplikasi tidak dapat mengakses:
                    </Typography>
                    <ul>
                      {!permissions.cameraAllowed && (
                        <li>
                          <strong>Kamera</strong>
                        </li>
                      )}
                    </ul>
                  </Typography>
                </Alert>
              )}

              <div className="mt-5">
                <LoginForm
                  onSubmit={handleSubmit}
                  disabled={!areAllPermissionsAllowed}
                />

                {configuration.OFFLINE_SIMULATION && (
                  <Button
                    type="button"
                    color="info"
                    className="mt-3"
                    onClick={handleSimulationClick}
                    block
                  >
                    Login
                  </Button>
                )}
              </div>

              <Typography variant="extra-small" className="text-center mt-10">
                Copyright&copy; 2026 Panitia Nasional SPAN-UM PTKIN
              </Typography>

              <img
                src={sponsor}
                className="w-full h-auto mx-auto pt-5"
                style={{
                  maxWidth: '150px',
                }}
                alt="sponsor"
              />
            </div>
          </div>

          {/* <LeafImage
            className="absolute md:block hidden w-60 h-auto"
            style={{
              top: '100px',
              right: '-120px',
              background: 'transparent',
            }}
          /> */}
        </div>

        <div className="md:col-span-6 md:block hidden relative">
          <img
            alt="donut-orbit"
            src={DonutOrbitImage}
            className="rounded-full absolute"
            style={{
              top: '15%',
              left: '-30%',
              width: '45rem',
              height: '45rem',
            }}
          />
        </div>
        <div
          className="md:col-span-6 md:block hidden relative bg-primary h-full overflow-hidden"
          style={{
            backgroundImage: 'linear-gradient(to right, #0D9C4E, #EF8A1B)',
            zIndex: 1,
          }}
        >
          {/* <div className="ml-20 flex flex-wrap content-center h-full">
            <FillFormImage className="mx-auto lg:w-55 md:w-48" />
          </div> */}

          <img
            alt="donut"
            src={DonutImage}
            className="rounded-full absolute"
            style={{
              top: '-240px',
              right: '-90px',
              opacity: '0.25',
            }}
          />

          <img
            alt="donut"
            src={DonutImage}
            className="rounded-full absolute"
            style={{
              bottom: '-240px',
              left: '-90px',
              opacity: '0.25',
            }}
          />
        </div>
      </div>
    </>
  );
}

export default LoginPage;
